module.exports = __webpack_public_path__ + "static/media/desk.97581b55.svg";